module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"instruction":"Memorer tidspunktet","timeSpanInstruction":"Memorer tidsrommet"},"en":{"instruction":"Memorize the time","timeSpanInstruction":"Memorize the time span"}}')
  delete Component.options._Ctor
}
